const Download = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11 13.586 6.707 9.293l-1.414 1.414L12 17.414l6.707-6.707-1.414-1.414L13 13.586V1h-2v12.586zM23 21H1v-5h2v3h18v-3h2v5z" fill="#000" />
    </svg>
)

export default Download;